import { createAction, props } from '@ngrx/store';

export const selectMaintenance = createAction('[Maintenances List Component] select', props<any>());
export const unselectMaintenance = createAction('[Maintenances List Component] unselect', props<any>());
export const resetSelectedMaintenances = createAction('[Maintenances List Component] reset');
